import { PATIENTS, PROVIDERS } from '../../route.const'

export const SIGN_IN_MENU_OPTIONS = [
  {
    title: 'Patient',
    url: `/${PATIENTS}/login`,
    description: 'Sign in as a patient',
    showLine: true,
  },
  {
    title: 'Clinician',
    url: `/${PROVIDERS}/login`,
    description: 'Sign in as a clinician',
    showLine: false,
  },
]

export const AUTH_TYPES = {
  MSID: 'msid',
  OHID: 'ohid',
} as const

export const HEADER_BREAKPOINTS = {
  mobile: 'md',
} as const
